forms-orders-search
  forms-search-form(tag-scope="{this.tagScope}")
  script(type="typescript").
    this.mixin('forms.orders.search')
